import { OnDestroy, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { UserService } from '../_services/user.service';
import { get, isEqual } from 'lodash';
import { MainmodelConstant } from '../_constants/UserPolicyConstants';
import { log } from 'console';
import { elementAt, Subject, takeUntil } from 'rxjs';
import { MenuSelectionService } from './service/menu-selection.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit, OnDestroy {
    model: any[] = [];
    Mainmodel: any[] = [];
    StorageData: any = [];
    newarray: any = [];
    updatedarray: any = [];
    menuModulesWithModuleId: any = [];
    moduleMenus: any = [];
    removeItems: any = [];
    private destroy$ = new Subject<void>();

    constructor(
        public layoutService: LayoutService,
        private userService: UserService,
        private menuSelectionService: MenuSelectionService
    ) {
        menuSelectionService
            .selectedItem$
            .pipe(takeUntil(this.destroy$))
            .subscribe((value) => {
                if (value != null && value?.class === 'level2-menu') {
                    if (value.items?.length > 0) {
                        this.isMenuExpanded = true;
                        this.layoutService.showMenuActive();
                        this.layoutService.showOverlayToggle();
                    }
                } else if (this.isMenuExpanded) {
                    this.toggleMenu();
                }
            });
    }

    isMenuExpanded = false;

    //after ngoninit()
    toggleMenu() {
        this.isMenuExpanded = !this.isMenuExpanded;
        this.layoutService.onMenuToggle();
    }

    onExpantable() {
        this.isMenuExpanded = false;
        this.layoutService.showOverlaysToggle();
    }

    ngOnInit() {
        var StorageDatad = localStorage.getItem('currentUser');
        const currentUserData = StorageDatad ? JSON.parse(StorageDatad) : null;
        this.StorageData = (currentUserData?.modules);
        this.newarray = (MainmodelConstant[0].items);
        this.menuModulesWithModuleId = currentUserData.user.userRoles[0].role.roleModuleMenuMapping;
        this.moduleMenus = currentUserData.moduleMenus;

        for (let i of this.newarray) {
            if (this.StorageData.find((x: any) => x.moduleName == i.ModuleName)) {
                if (this.menuModulesWithModuleId === null || this.menuModulesWithModuleId === undefined ||
                    this.menuModulesWithModuleId.length === 0) {
                    // Exiting roles
                    this.updatedarray.push(i);
                }
                else if (this.menuModulesWithModuleId.length > 0) {
                    // New Roles
                    const module = this.StorageData.find((x: any) => x.moduleName == i.ModuleName);
                    var moduleInfo = this.menuModulesWithModuleId.find((element: any) => element.policyId == 4 && element.moduleMenuId === 0
                        && module.moduleId == element.moduleId);

                    var moduleItems = i["items"];
                    if (moduleItems !== undefined) {
                        this.removeItems = [];
                        // If Items
                        moduleItems.forEach((item: any) => {

                            var moduleMenu = this.moduleMenus.find((x: any) => x.menuName.trim() === item.label.trim());
                            if (moduleMenu !== undefined) {
                                var checkpolicy = this.menuModulesWithModuleId.find((x: any) => x.moduleId === moduleMenu.moduleId
                                    && x.moduleMenuId === moduleMenu.moduleMenuId && x.policyId === 4)

                                if (checkpolicy !== undefined && moduleMenu.moduleMenuId === checkpolicy.moduleMenuId) {
                                    const y = moduleItems.indexOf(item);
                                    if (y >= 0) {

                                        //i["items"].splice(y, 1);
                                        this.removeItems.push(item);
                                    }
                                }
                            }
                        });

                        //
                        this.removeItems.forEach((item: any) => {
                            // i["items"].splice(item, 1);
                            i["items"] = i["items"].filter((x: any) => x.label.trim() !== item.label.trim());
                        });

                        this.updatedarray.push(i);
                    }
                    else {
                        // push with polciy Id
                        // assign Write and Full permission's to module
                        var moduleItemInfo = this.menuModulesWithModuleId.find((element: any) => module.moduleId == element.moduleId);
                        if (moduleItemInfo !== undefined) {

                            currentUserData.modules.forEach((x: any) => {
                                if (x.moduleId === moduleItemInfo.moduleId) {
                                    if (moduleItemInfo.policyId === 1) {
                                        x.policy = 'Read';
                                    }
                                    if (moduleItemInfo.policyId === 2) {
                                        x.policy = 'Write';
                                    }
                                    if (moduleItemInfo.policyId === 3) {
                                        x.policy = 'Full';
                                    }
                                    if (moduleItemInfo.policyId === 4) {
                                        x.policy = 'None';
                                    }
                                    else {
                                        this.updatedarray.push(i);
                                    }
                                }


                            });
                        }
                    }

                    localStorage.setItem('currentUser', JSON.stringify(currentUserData));
                }
            }
        }

        this.model = [
            {
                label: '',
                items: this.updatedarray,
            },
        ];
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
